export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  actions: {
    getCollection(store, payload) {
      return this.dispatch('get', {
        path: 'v1/applicationServer',
        ...payload
      }).then((res) => {
        return res && res.body
      })
    }
  },
  mutations: {
  }
}



// WEBPACK FOOTER //
// ./src/components/applicationServer/store.js